import {Component, Prop, Vue} from "vue-property-decorator";
import {Client} from "~/lib/models/client";
import {Label} from "~/components/forms/label";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import {XInput} from "~/components/forms/x-input";
import {TerritoryListComponent} from "~/components/territory-list";
import {Scroller} from "~/components/scroller";

@Component
export class ClientProfile extends Vue {

  @Prop({type: Object, required: true}) client: Client;

  render() {
    return (
      <div>

        <h2 class="page-subtitle">Informations du compte</h2>

        <Columns>
          <Column>
            <Label text="Nom client *"/>
            <XInput value={this.client.name} readonly/>
          </Column>
          <Column>
            <Label text="Code client *"/>
            <XInput value={this.client.code} readonly/>
          </Column>
        </Columns>

        {this.client.description && (
          <Columns>
            <Column>
              <Label text="Description"/>
              <textarea class="textarea" value={this.client.description} readonly/>
            </Column>
          </Columns>
        )}

        <h2 class="page-subtitle m-b-0">Territoire</h2>
        <small class="text">Découpage administratif, millésime {this.client.geomVersion["fr"]}</small>

        <Scroller class="territory-list-scroller m-t-20">
          <TerritoryListComponent  territory={this.client.territory} />
        </Scroller>

      </div>
    );
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2cb02ce9/profile.tsx" });